module.exports = __webpack_public_path__ + "static/media/train-prompt.a361805e.png";